import api from 'configs/api';

import { IInstallation, IInstallationAnomaly } from 'interfaces/Installation';
import { IRequestListResponse } from 'interfaces/RequestListResponse';

const endpointUrl = 'installation';

export const getInstallation = async (id?: string | number) => {
  const url = id ? `${endpointUrl}/${id}` : `${endpointUrl}/`;
  const { data } = await api.get<IRequestListResponse<IInstallation>>(url);
  return data;
};

export const postInstallationFilter = async params => {
  const url = `${endpointUrl}/cluster/`;
  const { data } = await api.post<IRequestListResponse<IInstallation>>(
    url,
    params,
  );
  return data;
};

export const postInstallationAnomalyFilter = async params => {
  const url = `${endpointUrl}/anomaly/filter-with-anomaly`;
  const { data } = await api.post<IRequestListResponse<IInstallationAnomaly>>(
    url,
    params,
  );
  return data;
};

export const postInstallationOptions = async params => {
  const url = `${endpointUrl}/cluster`;
  const { data } = await api.post<IRequestListResponse<IInstallation>>(
    url,
    params,
  );
  return data;
};

export const postAddInstallation = async params => {
  const url = `${endpointUrl}/add`;
  const { data } = await api.post<IRequestListResponse<null>>(url, params);
  return data;
};

export const getInstallationFilter = async () => {
  const url = `${endpointUrl}`;
  const { data } = await api.get<IRequestListResponse<IInstallation>>(url);
  return data;
};
